import { TReaderDocument } from '@app-evolution-cms/email-builder';

function isReaderDocument(value: unknown): value is TReaderDocument {
  return typeof value === 'object' && value !== null && !Array.isArray(value) && 'root' in value;
}

/** Accepts both a raw document and the `{ json, html }` payload produced by `getContent()`. */
export function parseEmailBuilderDocument(value: unknown): TReaderDocument | undefined {
  if (typeof value !== 'string' || value.trim() === '') return undefined;

  try {
    const parsedValue: unknown = JSON.parse(value);

    if (isReaderDocument(parsedValue)) return parsedValue;

    if (
      typeof parsedValue === 'object' &&
      parsedValue !== null &&
      'json' in parsedValue &&
      isReaderDocument(parsedValue.json)
    ) {
      return parsedValue.json;
    }
  } catch {
    return undefined;
  }

  return undefined;
}
